import React from "react";
import { Link } from "react-router-dom";
import "./ServicesDetail.css";
import neuroImg from "../../assets/images/neuro.png";

function NeuroPT() {
  return (
    <div className="service-detail-container">
      <div className="service-detail-image">
        <img src={neuroImg} alt="Neuro Physical Therapy" />
      </div>
      <div className="service-detail-content">
        <h2>Neuro Physical Therapy</h2>
        <p>
          Neuro physical therapy specializes in helping patients with neurological
          conditions (such as stroke, multiple sclerosis, Parkinson’s) improve
          their mobility and daily functioning.
        </p>
        <p>
          <strong>When is it needed?</strong>

            If you are recovering from a stroke, living with a progressive neurological
          disease, or struggling with balance and coordination issues, neuro PT can
          enhance your independence.
        </p>
        <ul className="service-bullet-list">
          <li>Balance and gait training</li>
          <li>Coordination and movement re-education</li>
          <li>Strength and endurance exercises</li>
        </ul>
        <p>
          Our approach includes task-specific training, neuromuscular facilitation,
          and assistive device recommendations, all aimed at improving your quality
          of life.
        </p>

        <Link to="/contact" className="service-cta-button">
          Contact Us to Learn More
        </Link>
      </div>
    </div>
  );
}

export default NeuroPT;
